<template>
  <section id="home" class="pt-24 md:pt-32 pb-16 md:pb-24 bg-neutral-100">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 mb-10 md:mb-0">
          <h1 class="text-[clamp(2rem,5vw,3.5rem)] font-bold text-neutral-700 leading-tight mb-4">
            合规为基、技术为翼<br>
            <span class="text-primary" style="font-size:26px;">构建全链条服务体系</span>
          </h1>
          <p class="text-lg md:text-xl text-neutral-500 mb-8 max-w-lg">
            我们打造的专业法律咨询平台，是企业在复杂商业环境中实现合规经营与数字化增长的 “智慧伙伴”。
          </p>
          <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <a
                href="#contact" style="color:#E6733A"
                class="px-8 py-3 bg-primary hover:bg-primary/90 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 text-center"
            >
              立即咨询
            </a>
            <a
                href="#services"
                class="px-8 py-3 bg-white hover:bg-neutral-50 text-primary border border-primary font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-center"
            >
              了解更多
            </a>
          </div>
        </div>
        <div class="md:w-1/2 flex justify-center">
          <div class="relative w-full max-w-md">
            <div class="absolute inset-0 bg-gradient-primary rounded-2xl transform rotate-3 opacity-20"></div>
            <img :src="require('@/assets/forlaw.png')" alt="创新解决方案" class="relative z-10 rounded-xl shadow-2xl w-full h-auto">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Hero'
  }
</script>
